import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CrisprComponent } from './crispr/crispr.component';
import { CrisprQueryResolve } from './crispr/crispr.resolve';
import { ExchangeComponent } from './exchange/exchange.component';
import { ExchangeQueryResolve } from './exchange/exchange.resolve';
import { MySwarmComponent } from './my-swarm/my-swarm.component';
import { MySwarmQueryResolve } from './my-swarm/my-swarm.resolve';
import { PopulationComponent } from './population/population.component';
import { PopulationQueryResolve } from './population/population.resolve';
import { ProfileComponent } from './profile/profile.component';
import { RegisterComponent } from './register/register.component';
import { ActivationComponent } from './shared/activation/activation.component';
import { AuthGuard } from './shared/auth/auth-guard.service';

const routes: Routes = [
	{	path: 'population',
		component: PopulationComponent,
		resolve: {data: PopulationQueryResolve},
		runGuardsAndResolvers: 'paramsOrQueryParamsChange'
	},
	{	path: 'my-swarm',
		component: MySwarmComponent,
		resolve: {data: MySwarmQueryResolve},
		runGuardsAndResolvers: 'paramsOrQueryParamsChange',
		canActivate: [AuthGuard]
	},
	{path: 'profile', component: ProfileComponent, canActivate: [AuthGuard]},
	{path: 'register', component: RegisterComponent},
	{	path: 'exchange',
		component: ExchangeComponent,
		resolve: {data: ExchangeQueryResolve},
		runGuardsAndResolvers: 'paramsOrQueryParamsChange'
	},
	{	path: 'crispr',
		component: CrisprComponent,
		resolve: {data: CrisprQueryResolve},
		runGuardsAndResolvers: 'paramsOrQueryParamsChange'
	},
	{	path: 'activation/:resetKey',
		component: ActivationComponent
	},
	// temporary redirect to population
	{
		path: '',
		redirectTo: 'population',
		pathMatch: 'full'
	},
	// if not found, redirect to root
	{	path: '**', redirectTo: '/' }
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule {}